import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(theme => ({
   formRadio:{
       '& .MuiRadio-root':{
           color:'#6200ee'
       }
   },
   truckTypeIcon: {
     width: 32,
     // height: 'auto',
     textAlign: "center"
   },
   imgDiv: {
     height: 32
   },
   iconGrid: {
     textAlign: 'center',
     margin: "10px 0"
   },
   iconGridSelected: {
     textAlign: 'center',
     margin: "10px 0",
     borderRadius: 10,
     border: "1px solid #0033cc",
     color: "#0033cc"
   },
   vehicleTypeDiv: {
     paddingBottom: 15,
     marginBottom: 15,
     borderBottom: "2px dashed #c7c7c7"
   },
   vehicleTypeLabel: {
     margin: "10px 0",
     color: "rgba(0, 0, 0, 0.54)",
     padding: 0,
     fontSize: "1rem",
     fontWeight: 400,
     lineHeight: 1,
     letterSpacing: "0.00938em"
   },
   iconLabel: {
     marginBottom: 0,
   },
   iconLabelSee: {
     marginBottom: 0,
     color: "#0033cc"
   },
   iconLabelSeeIcon: {
     color: "#0033cc"
   },
   truckAddButton: {
     margin: 5,
     textTransform: "capitalize",
     fontWeight: 600,
     padding: "7px 16px",
     borderRadius: 8,
     color: "#0033cc",
     borderColor: "#0033cc"
   },
   margin: {
     margin: theme.spacing(1),
   },
   formMarginBottom: {
     marginBottom: theme.spacing(1),
   },
   reminderInput:{
    width:'100%',
    display:'flex',
    alignItems:'center'
   },
   reminderselect:{
     '& .MuiSelect-select':{
        paddingTop:2,
        paddingBottom:2
     }
   },
   selectDiv:{
    marginLeft:4
   }
  }));
export default useStyles;